<div class="item user-block" *ngIf="userBlockIsVisible()">
  <!-- User picture-->
  <div class="user-block-picture">
    <div class="user-block-status">
      <img class="img-thumbnail rounded-circle" [src]="picture" alt="Avatar" />
      <div class="circle bg-success circle-lg"></div>
    </div>
  </div>
  <!-- Name and Job-->
  <div class="user-block-info">
    <span class="user-block-name"><em class="fa fa-user"></em> {{name}}</span>
    <span class="user-block-role"><em class="fa fa-key"></em> {{role}}</span>
  </div>
</div>
